document.addEventListener("DOMContentLoaded", () => {
    initEventSlideReel();
    const id_product = window.location.search.slice(4);
    const list_reel = document.querySelectorAll("swiper-slide .modal-wrapper");
    const list_reel_id = [];
    for (var i = 0; i < window.reelProducts.length; i++) {
        list_reel_id.push(String(window.reelProducts[i]["id"]));
    }
    if (list_reel_id.includes(id_product) === true) {
        initDataReel(id_product, true);
        Array.from(list_reel).forEach(element => {
            const id = element.parentElement.getAttribute("data-id");
            const element_div_swiper = document.getElementById("div-reel");
            element_div_swiper.classList.remove("hidden");
            element_div_swiper.classList.add("flex");
            element.classList.remove("hidden");
        })
    }
    const videoReel = $(".hoverVideo");
    Array.from(videoReel).forEach(element => {
        element.addEventListener('mouseover', () => {
            element.querySelector("video").play();
        });
        element.addEventListener('mouseout', () => {
            element.querySelector("video").pause();
        });
    });
    Array.from(videoReel).forEach(element => {
        element.addEventListener("click", async (e) => {
            const element_div_swiper = document.getElementById("div-reel");
            element_div_swiper.classList.remove("hidden");
            element_div_swiper.classList.add("flex");
            const element_modals = document.getElementsByClassName("modal-wrapper")
            Array.from(element_modals).forEach(element => {
                element.classList.remove("hidden");
            })
            const id_product = e.target.parentElement.getAttribute("data-id-product");
            window.history.pushState(
                {},
                '',
                `${window.location.pathname}?id=${id_product}`
            );
            initDataReel(id_product);
        })
    })
    closeModal();
})

function renderImage(listImageProduct, id_product) {
    const testDiv = document.querySelector(`swiper-slide[data-id="${id_product}"]`);
    let currentDiv
    if (testDiv) {
        currentDiv = testDiv.querySelector(".slider-image-product")
    }
    else {
        currentDiv = document.querySelector(".slider-image-product");
    }
    currentDiv.innerHTML = ''
    for (i = 0; i < listImageProduct.length; i++) {
        const swiperSlide = document.createElement("swiper-slide");
        const imageElement = document.createElement("img");
        imageElement.classList.add(
            'h-[314px]',
            'w-[314px]',
            'img-product',
            'rounded-4xl',
            'slide',
        )
        swiperSlide.setAttribute("data-product_id", id_product)
        imageElement.setAttribute("src", listImageProduct[i])
        swiperSlide.appendChild(imageElement)
        currentDiv.appendChild(swiperSlide)
    }
}
function renderDots(listImageProduct, swiper, id_product) {
    const testDiv = document.querySelector(`swiper-slide[data-id="${id_product}"]`);
    let currentDiv
    if (testDiv) {
        currentDiv = testDiv.querySelector(".dots")
    }
    else {
        currentDiv = document.querySelector(".dots");
    }
    currentDiv.innerHTML = "";
    for (i = 0; i < listImageProduct.length; i++) {
        const listDots = document.createElement("button")
        listDots.classList.add(
            'w-2',
            'h-2',
            'bg-neutral-10',
            'rounded-full',
            'dot'
        )
        if (i === 0) listDots.classList.add('active');
        listDots.addEventListener('click', () => swiper.slideTo(i));
       
        currentDiv.appendChild(listDots);
    }
}

function initImageSlider(imageList, id_product) {
    const swiperModal = document.querySelector(`swiper-slide[data-id="${id_product}"]`);
    let currentModal =  swiperModal ? swiperModal: document
    let swiperBanner = currentModal.querySelector('swiper-container.slider-image-product');
    // swiperBanner = Array.from(swiperBanner).find((element) => {
    //     return element.offsetParent !== null;
    // });
    const paginationEl = document.querySelector(`swiper-slide[data-id="${id_product}"] .dots`);
    // if (!swiperBanner) return;
    const swiper = swiperBanner.swiper;
    renderDots(imageList, swiper, id_product);
    paginationEl.querySelectorAll('button').forEach((dot, index) => {
        const activeIndex = swiper.activeIndex;
        dot.classList.toggle('active', index === activeIndex);
        if (dot.classList.contains('active')) {
            dot.classList.add("bg-neutral-20");
            dot.classList.remove("bg-neutral-10");
        }
    });
    swiper.on('slideChange', () => {
        const activeIndex = swiper.activeIndex;
        paginationEl.querySelectorAll('button').forEach((dot, index) => {
            dot.classList.toggle('active', index === activeIndex);
            if (index === activeIndex) {
                dot.classList.add("bg-neutral-20");
                dot.classList.remove("bg-neutral-10");
            }
            else {
                dot.classList.remove("bg-neutral-20");
                dot.classList.add("bg-neutral-10");
            }
        });
    });
    currentDiv = swiperModal ? swiperModal : document
    const oldPrevBtn = currentDiv.querySelector('.prev-slide-image-btn')
    const newPrevBtn = oldPrevBtn.cloneNode(true)
    newPrevBtn.addEventListener('click', () => {
        swiper.slidePrev();
    });
    oldPrevBtn.parentNode.replaceChild(newPrevBtn, oldPrevBtn)

    const oldNextBtn = currentDiv.querySelector('.next-slide-image-btn')
    const newNextBtn = oldNextBtn.cloneNode(true)
    newNextBtn.addEventListener('click', () => {
        swiper.slideNext();
    });
    oldNextBtn.parentNode.replaceChild(newNextBtn, oldNextBtn)
}

function initReelSlider() {
    let swiperBanner = document.querySelector('swiper-container#slider-reel');
    const listReelSlide = document.querySelector(
        '#slider-reel'
    );

    const swiper = swiperBanner.swiper;
    setTimeout(function() {
        const firstReel = swiper.isBeginning;
        const lastReel = swiper.isEnd;
        const btn_preview = document.querySelector("#prev-slide-reel-btn");
        const btn_next = document.querySelector("#next-slide-reel-btn");
        if (firstReel) {
            btn_preview.classList.remove("xl:visible");
        }
        if (lastReel) {
            btn_next.classList.remove("xl:visible");
        }
    }, 100)
    swiper.on('slideChange', () => {
        const activeIndex = swiper.activeIndex;
        disableButtonSlide(swiper);
        listReelSlide.querySelectorAll('swiper-slide.reel').forEach((reel, index) => {
            if (index === activeIndex) {
                const id_product = reel.getAttribute("data-id");
                for (var i = 0; i < window.reelProducts.length; i++) {
                    if (window.reelProducts[i]["id"] == id_product) {
                        const elements_title = document.getElementsByClassName("title-product");
                        const elements_price = document.getElementsByClassName("price");
                        const element_image = document.getElementsByClassName("image-product-shop");
                        const elements_video = document.getElementsByClassName("src-video")
                        const element_url_shop = document.getElementsByClassName("url-shop-now");
                        Array.from(elements_title).forEach(element => {
                            element.innerHTML = window.reelProducts[i]["title"]
                        })
                        Array.from(elements_price).forEach(element => {
                            element.innerHTML = `$${window.reelProducts[i]["price"] / 100.0} USD`;
                        })
                        Array.from(element_image).forEach(element => {
                            element.setAttribute("src", window.reelProducts[i]["images"][0]);
                        })
                        Array.from(element_url_shop).forEach(element => {
                            element.setAttribute("href", window.reelProducts[i]["url"]);
                        })
                        Array.from(elements_video).forEach(element => {
                            element.setAttribute("src", window.reelProducts[i]["metafields"])
                            element.setAttribute("poster", window.reelProducts[i]["poster"])
                            element.parentElement.load()
                        })
                        renderImage(window.reelProducts[i]["images"], id_product);
                        initImageSlider(window.reelProducts[i]["images"], id_product);
                    }
                
                }
                const element_shop_now = document.querySelector(`swiper-slide[data-id="${id_product}"] #shop-now`);
                const element_cancel_shop_now = document.querySelector(`swiper-slide[data-id="${id_product}"] #cancel-shop-now`);
                const element_btn_share = document.querySelector(`swiper-slide[data-id="${id_product}"] #btn-share`);
                const element_cancel_share = document.querySelector(`swiper-slide[data-id="${id_product}"] #cancel-share`);
                const element_share = document.querySelector(`swiper-slide[data-id="${id_product}"] .share`);
                element_shop_now.addEventListener("click", (e) => {
                    element_shop_now.classList.add("hidden")
                    const element_shop_product = document.querySelector(`swiper-slide[data-id="${id_product}"] #shop-product`);
                    element_shop_product.classList.remove("hidden");
                    for (var i = 0; i < window.reelProducts.length; i++) {
                        if (window.reelProducts[i]["id"] == id_product) {
                            const elements_title = document.getElementsByClassName("title-product");
                            const elements_price = document.getElementsByClassName("price");
                            const element_image = document.getElementsByClassName("image-product-shop");
                            const element_url_shop = document.getElementsByClassName("url-shop-now");

                            Array.from(elements_title).forEach(element => {
                                element.innerHTML = window.reelProducts[i]["title"]
                            })
                            Array.from(elements_price).forEach(element => {
                                element.innerHTML = `$${window.reelProducts[i]["price"] / 100.0} USD`;
                            })
                            Array.from(element_image).forEach(element => {
                                element.setAttribute("src", window.reelProducts[i]["images"][0]);
                            })
                            Array.from(element_url_shop).forEach(element => {
                                element.setAttribute("href", window.reelProducts[i]["url"]);
                            })
                        }
                    }
                })
                element_cancel_shop_now.addEventListener("click", (e) => {
                    const element_shop_product = document.querySelector(`swiper-slide[data-id="${id_product}"] #shop-product`);
                    element_shop_product.classList.add("hidden");
                    element_shop_now.classList.remove("hidden");
                })
                element_btn_share.addEventListener("click", () => {
                    const element_shop_product = document.querySelector(`swiper-slide[data-id="${id_product}"] #shop-product`);
                    element_shop_now.classList.add("hidden");
                    element_shop_product.classList.add("hidden");
                    element_share.classList.remove("hidden");
                    shareSection(id_product);
                })
                element_cancel_share.addEventListener("click", () => {
                    element_share.classList.add("hidden");
                    element_shop_now.classList.remove("hidden");
                })
                window.history.pushState(
                    {},
                    '',
                    `${window.location.pathname}?id=${id_product}`
                );
                muteVideo(id_product);
                playVideo(id_product);
                const elemnt_video_modal = document.querySelector(`swiper-slide[data-id="${id_product}"] .video-modal`);
                const element_button_play = document.querySelector(`swiper-slide[data-id="${id_product}"] .button-play-reel`);
                const element_gradient = document.querySelector(`swiper-slide[data-id="${id_product}"] #gradient `)
                element_button_play.classList.remove("hidden");
                element_gradient.classList.add("bg-gradient-to-b");
                elemnt_video_modal.querySelector("video").pause();
                clickOutModal(id_product);
            }
        });
    });
}

function closeModal() {
    const btn_close_mobi = document.getElementsByClassName("btn-close-modal-mobi");
    const btn_close = document.getElementById("btn-close-modal");
    if (btn_close_mobi) {
        Array.from(btn_close_mobi).forEach(element => {
            element.addEventListener("click", () => {
                const id_product = window.location.search.slice(4);
                const element_div_swiper = document.getElementById("div-reel");
                const elemnt_video_modal = document.querySelector(`swiper-slide[data-id="${id_product}"] .video-modal`);
                const element_button_play = document.querySelector(`swiper-slide[data-id="${id_product}"] .button-play-reel`);
                const element_gradient = document.querySelector(`swiper-slide[data-id="${id_product}"] #gradient `)
                element_button_play.classList.remove("hidden");
                element_gradient.classList.add("bg-gradient-to-b");
                elemnt_video_modal.querySelector("video").pause();
                element_div_swiper.classList.add("hidden");
                element_div_swiper.classList.remove("flex");
                const element_modals = document.getElementsByClassName("modal-wrapper")
                Array.from(element_modals).forEach(element => {
                    element.classList.add("hidden");
                })
                window.history.pushState(
                    {},
                    '',
                    `${window.location.pathname}`
                );
            })
        })
    }
    if (btn_close) {
        btn_close.addEventListener("click", () => {
            const id_product = window.location.search.slice(4);
            const element_div_swiper = document.getElementById("div-reel");
            const elemnt_video_modal = document.querySelector(`swiper-slide[data-id="${id_product}"] .video-modal`);
            const element_button_play = document.querySelector(`swiper-slide[data-id="${id_product}"] .button-play-reel`);
            const element_gradient = document.querySelector(`swiper-slide[data-id="${id_product}"] #gradient `);
            element_button_play.classList.remove("hidden");
            element_gradient.classList.add("bg-gradient-to-b");
            elemnt_video_modal.querySelector("video").pause();
            element_div_swiper.classList.add("hidden");
            element_div_swiper.classList.remove("flex");
            const element_modals = document.getElementsByClassName("modal-wrapper")
            Array.from(element_modals).forEach(element => {
                element.classList.add("hidden");
            })
            window.history.pushState(
                {},
                '',
                `${window.location.pathname}`
            );
        })
    }
}

function directionReel() {
    const swiperEl = document.querySelector('swiper-container#slider-reel')
    Object.assign(swiperEl, {
      breakpoints: {
        350: {
          direction: "vertical",
        },
        768: {
          direction: "horizontal",
        },
      },
    });
    swiperEl.initialize();
}

function initEventSlideReel() {
    let swiperBanner = document.querySelector('swiper-container#slider-reel');
    const swiper = swiperBanner.swiper;
    document
        .querySelector('#prev-slide-reel-btn')
        .addEventListener('click', () => {
            swiper.slidePrev();
        });

    document
        .querySelector('#next-slide-reel-btn')
        .addEventListener('click', () => {
            swiper.slideNext();
        });
} 

function initEventSlideImage() {
    let swiperBanner = document.querySelectorAll('swiper-container.slider-image-product');
    swiperBanner = Array.from(swiperBanner).find((element) => {
        return element.offsetParent !== null;
    });
    if (!swiperBanner) return;
    const swiper = swiperBanner.swiper;
    document
    .querySelector('.prev-slide-image-btn')
    .addEventListener('click', () => {
        swiper.slidePrev();
    });

    document
    .querySelector('.next-slide-image-btn')
    .addEventListener('click', () => {
        swiper.slideNext();
    });
}

function muteVideo(id_product) {
    const element_video = document.querySelector(`swiper-slide[data-id="${id_product}"] .video-reel`)
    if (!element_video) return;
    const element_unmuted_old = document.querySelector(`swiper-slide[data-id="${id_product}"] .unmute-video`)
    const element_unmuted_new = element_unmuted_old.cloneNode(true)
    const element_muted_old = document.querySelector(`swiper-slide[data-id="${id_product}"] .mute-video`)
    const element_muted_new = element_muted_old.cloneNode(true)
    element_unmuted_new.addEventListener("click", () => {
        element_video.muted = !element_video.muted;
        element_unmuted_new.classList.add("hidden");
        element_muted_new.classList.remove("hidden");
    })
    element_muted_new.addEventListener("click", () => {
        element_video.muted = !element_video.muted;
        element_muted_new.classList.add("hidden");
        element_unmuted_new.classList.remove("hidden");
    })
    element_muted_old.parentNode.replaceChild(element_muted_new, element_muted_old);
    element_unmuted_old.parentNode.replaceChild(element_unmuted_new, element_unmuted_old);
}

function shareSection(id_product) {
    const element_share_facebook = document.querySelector(`swiper-slide[data-id="${id_product}"] .share-facebook`);
    const element_share_twitter = document.querySelector(`swiper-slide[data-id="${id_product}"] .share-twitter`)
    const element_share_mail = document.querySelector(`swiper-slide[data-id="${id_product}"] .share-mail`)
    const element_copy_link = document.querySelector(`swiper-slide[data-id="${id_product}"] .copy-link`)
    const index = window.location.href.lastIndexOf("=");
    const url = window.location.href.substring(0, index + 1) + id_product;
    const result = encodeURIComponent(url);
    const href_share_facebook = `https://www.facebook.com/sharer/sharer.php?u=${result}`;
    const href_share_twitter = `https://twitter.com/intent/tweet?url=${result}`;
    const href_share_mail = `mailto:?subject=I wanted you to see this site&body=Check out this site ${url}.`;
    element_share_facebook.setAttribute("href", href_share_facebook);
    element_share_twitter.setAttribute("href", href_share_twitter);
    element_share_mail.setAttribute("href", href_share_mail);
    element_copy_link.addEventListener("click", () => {
        handleCopy(id_product);
    })
}

const copyToClipboard = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
    } catch (error) {
      console.error("Error when copying text: ", error);
    }
  };

const handleCopy = (id_product) => {
    const index = window.location.href.lastIndexOf("=");
    const url = window.location.href.substring(0, index + 1) + id_product;
    copyToClipboard(url);
};

function initDataReel (id_product) {
    for (var i = 0; i < window.reelProducts.length; i++) {
        if (window.reelProducts[i]["id"] == id_product) {
            document.querySelector("#slider-reel").swiper.slideTo(i)
            const elements_title = document.getElementsByClassName("title-product")
            const elements_price = document.getElementsByClassName("price")
            const elements_video = document.getElementsByClassName("src-video")
            const element_url_shop = document.getElementsByClassName("url-shop-now");
            Array.from(elements_title).forEach(element => {
                element.innerHTML = window.reelProducts[i]["title"]
            })
            Array.from(elements_price).forEach(element => {
                element.innerHTML = `$${window.reelProducts[i]["price"] / 100.0} USD`
            })
            Array.from(elements_video).forEach(element => {
                element.setAttribute("src", window.reelProducts[i]["metafields"])
                element.setAttribute("poster", window.reelProducts[i]["poster"])
                element.parentElement.load()
            })
            Array.from(element_url_shop).forEach(element => {
                element.setAttribute("href", window.reelProducts[i]["url"]);
            })
            renderImage(window.reelProducts[i]["images"], window.reelProducts[i]["id"]);
            initImageSlider(window.reelProducts[i]["images"], window.reelProducts[i]["id"]);
            initReelSlider();
        }
    }
    playVideo(id_product);
    const element_shop_now = document.querySelector(`swiper-slide[data-id="${id_product}"] #shop-now`);
    const element_cancel_shop_now = document.querySelector(`swiper-slide[data-id="${id_product}"] #cancel-shop-now`);
    const element_btn_share = document.querySelector(`swiper-slide[data-id="${id_product}"] #btn-share`);
    const element_cancel_share = document.querySelector(`swiper-slide[data-id="${id_product}"] #cancel-share`);
    const element_share = document.querySelector(`swiper-slide[data-id="${id_product}"] .share`);
    const element_shop_product = document.querySelector(`swiper-slide[data-id="${id_product}"] #shop-product`);
    element_shop_now.addEventListener("click", (e) => {
        element_shop_now.classList.add("hidden")
        element_shop_product.classList.remove("hidden");
        for (var i = 0; i < window.reelProducts.length; i++) {
            if (window.reelProducts[i]["id"] == id_product) {
                const elements_title = document.getElementsByClassName("title-product");
                const elements_price = document.getElementsByClassName("price");
                const element_image = document.getElementsByClassName("image-product-shop");
                const element_url_shop = document.getElementsByClassName("url-shop-now");

                Array.from(elements_title).forEach(element => {
                    element.innerHTML = window.reelProducts[i]["title"]
                })
                Array.from(elements_price).forEach(element => {
                    element.innerHTML = `$${window.reelProducts[i]["price"] / 100.0} USD`;
                })
                Array.from(element_image).forEach(element => {
                    element.setAttribute("src", window.reelProducts[i]["images"][0]);
                })
                Array.from(element_url_shop).forEach(element => {
                    element.setAttribute("href", window.reelProducts[i]["url"]);
                })
            }
        }
    })
    element_btn_share.addEventListener("click", () => {
        element_shop_now.classList.add("hidden");
        element_shop_product.classList.add("hidden");
        element_share.classList.remove("hidden");
        shareSection(id_product);
    })
    element_cancel_share.addEventListener("click", () => {
        element_share.classList.add("hidden");
        element_shop_now.classList.remove("hidden");
    })
    muteVideo(id_product);
    element_cancel_shop_now.addEventListener("click", (e) => {
        element_shop_product.classList.add("hidden");
        element_shop_now.classList.remove("hidden");
    })
    directionReel();
    clickOutModal(id_product);
}

function disableButtonSlide(swiper) {
    const firstReel = swiper.isBeginning;
    const lastReel = swiper.isEnd;
    const btn_preview = document.querySelector("#prev-slide-reel-btn");
    const btn_next = document.querySelector("#next-slide-reel-btn");
    if (firstReel) {
        btn_preview.classList.remove("xl:visible");
    }
    else {
        btn_preview.classList.add("xl:visible")
    }
    if (lastReel) {
        btn_next.classList.remove("xl:visible");
    }
    else {
        btn_next.classList.add("xl:visible");
    }
}

function playVideo(id_product) {
    const elemnt_video_modal = document.querySelector(`swiper-slide[data-id="${id_product}"] .video-modal`)
    const old_element_gradient = document.querySelector(`swiper-slide[data-id="${id_product}"] #gradient `)
    const new_element_gradient = old_element_gradient.cloneNode(true);
    const element_button_play = new_element_gradient.children[0]
    new_element_gradient.addEventListener('click', () => {
        if (elemnt_video_modal.querySelector("video").paused) {
            elemnt_video_modal.querySelector("video").play();
            new_element_gradient.children[0].classList.add("hidden");
            new_element_gradient.classList.remove("bg-gradient-to-b");
            elemnt_video_modal.querySelector("video").addEventListener('ended', () => {
                new_element_gradient.children[0].classList.remove("hidden");
                new_element_gradient.classList.add("bg-gradient-to-b");
            });
        }
        else {
            elemnt_video_modal.querySelector("video").pause();
            new_element_gradient.children[0].classList.remove("hidden");
            new_element_gradient.classList.add("bg-gradient-to-b");
        }
    })
    element_button_play.addEventListener("click", (e) => {
        e.stopPropagation()
        if (elemnt_video_modal.querySelector("video").paused) {
            elemnt_video_modal.querySelector("video").play();
            new_element_gradient.children[0].classList.add("hidden");
            new_element_gradient.classList.remove("bg-gradient-to-b");
            elemnt_video_modal.querySelector("video").addEventListener('ended', () => {
                new_element_gradient.children[0].classList.remove("hidden");
                new_element_gradient.classList.add("bg-gradient-to-b");
            });
        }
    })
    old_element_gradient.parentNode.replaceChild(new_element_gradient, old_element_gradient)
}

function clickOutModal(id_product) {
    const element_slide_reel = document.querySelector("#div-reel");
    document.addEventListener('click', function(event) {
        if(event.target.id == "div-reel"){
            const elemnt_video_modal = document.querySelector(`swiper-slide[data-id="${id_product}"] .video-modal`);
            const element_button_play = document.querySelector(`swiper-slide[data-id="${id_product}"] .button-play-reel`);
            const element_gradient = document.querySelector(`swiper-slide[data-id="${id_product}"] #gradient `);
            element_button_play.classList.remove("hidden");
            element_gradient.classList.add("bg-gradient-to-b");
            elemnt_video_modal.querySelector("video").pause();
            element_slide_reel.classList.add("hidden")
            window.history.pushState(
                {},
                '',
                `${window.location.pathname}`
            );
        }
      });
}
